import { Padding } from "@mui/icons-material";
import { CustomButton } from "../../../Utilities/Buttons";
import Brain from '../../../.././Assets/img/brain.png';
import Images from '../../../../Assets/img/ImageUtilities'
import { useNavigate } from "react-router-dom";
import { getPersonalityTestResult } from "../../../../Redux/Reducers/numerologyReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const ParentComponent = ({ children, className = "" }) => {
     const Numerology = useSelector((state) => state?.numerology?.personalityTestResult);
    const navigate = useNavigate();
    const dispatch= useDispatch()
    
    console.log("Numerology....", Numerology)

    const handlePersonalDetails = () => {
        dispatch(getPersonalityTestResult())
        navigate('/personalDetails')
    };

    const handlePersonalTest = () => {
        navigate('/personalitytest')
    };

    const handlePersonalitySaboteur = () => {
        navigate('/personalitySaboteur');
    };

    return (
        <div className="d-flex flex-row" style={{ height: "86%" }}>
            <div className={`${className}`} style={{ width: "80%", height: "100%" }}>
                {children}
            </div>
            <div className="d-flex flex-column align-items-center gap-4 px-2 pt-5 shadow" style={{ width: "25%" }}>
                <CustomButton label="Personality Result" bgColor="#ffffff" color="#2a2929ff" image={Images.Personaldetails} sx={{ boxShadow: '0px 4px 10px rgba(102, 95, 95, 0.25)', width: "60%", border: "1px solid rgba(0,82,204,0.2)" }} handleOnClick={handlePersonalDetails} />
                <CustomButton label={Numerology?.user_ref_id ? "Take Test Again" : "Personality Test"} bgColor="#ffffff" color="#2a2929ff" image={Images.Brain} sx={{ boxShadow: '0px 4px 10px rgba(102, 95, 95, 0.25)', width: "60%", border: "1px solid rgba(0,82,204,0.2)" }} handleOnClick={handlePersonalTest} />
                <CustomButton label="Personality Saboteur" bgColor="#ffffff" color="#2a2929ff" image={Images.IDcard} sx={{ boxShadow: '0px 4px 10px rgba(102, 95, 95, 0.25)', width: "60%", border: "1px solid rgba(0,82,204,0.2)", paddingTop: "5px", }} handleOnClick={handlePersonalitySaboteur} />
            </div>
        </div>
    );
};

export default ParentComponent;